import { render, staticRenderFns } from "./TelstraUIVueDialog.vue?vue&type=template&id=bb9dfed4"
import script from "./TelstraUIVueDialog.vue.ts?vue&type=script&lang=ts&external"
export * from "./TelstraUIVueDialog.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports